import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import Modal from '@material-ui/core/Modal';
import API from '../../../create/api';
import DeleteIcon from '@material-ui/icons/Delete';
import IconButton from '@material-ui/core/IconButton';
import EditIcon from '@material-ui/icons/Edit';
import { Box, LinearProgress, Pagination, TextField } from '@mui/material';
import _, { debounce } from 'lodash';
import querystring from 'querystring';
const useStyles = makeStyles((theme) => ({
  table: {
    minWidth: 700,
  },
  search: {
    display: 'flex',
  },
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    border: '2px solid #000',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
}));

export default function SpanningTable() {
  const classes = useStyles();
  const [rows, setRows] = useState([]);
  const [get_page_no, set_page_no] = useState(1);
  const [get_total_area_count, set_total_area_count] = useState(0);
  const [loading, setLoading] = useState(false);

  const initialLimit = localStorage.getItem('areaLimit') ? JSON.parse(localStorage.getItem('areaLimit') ?? '') : 500;
  const initialSortType = localStorage.getItem('sortArea')
    ? JSON.parse(localStorage.getItem('sortArea') ?? '')
    : 'id:ASC';
  const [limit, setLimit] = React.useState(initialLimit);
  const [sortBy, setSortBy] = useState(initialSortType);
  const [search, setSearch] = useState('');

  const apiName = 'areas';
  async function fetchAPI() {
    setLoading(true);
    const getArea = {
      _start: (get_page_no - 1) * limit,
      _limit: limit,
      _sort: sortBy,
      _q: search,
    };
    const param = querystring.encode(_.pickBy(getArea, _.identity));
    const [areas, count]: any[] = await Promise.all([
      API.getAll(`${process.env.REACT_APP_API_SERVER}/${apiName}?${param}`),
      API.count(`${process.env.REACT_APP_API_SERVER}/areas/count?${param}`),
    ]);
    setRows(areas);
    set_total_area_count(count);
    setLoading(false);
  }

  useEffect(() => {
    fetchAPI();
  }, [get_page_no, limit, sortBy, search]);

  const history = useHistory();

  const [deleteID, setDeleteID] = useState(undefined);
  const [open, setOpen] = React.useState(false);

  const handleOpen = (id: any) => {
    setDeleteID(id);
    setOpen(true);
  };
  const handleClose = () => {
    setDeleteID(undefined);
    setOpen(false);
  };

  // rest api
  async function deleteAPN() {
    if (deleteID) {
      await API.destroy(`${process.env.REACT_APP_API_SERVER}/${apiName}`, deleteID)
        .then((res) => {
          fetchAPI();
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => {
          handleClose();
        });
    }
  }

  const handleSearchField = debounce((searchValue: string) => {
    setSearch(searchValue);
  }, 3000);

  return (
    <TableContainer component={Paper}>
      {loading && <LinearProgress />}
      <Modal
        aria-labelledby="spring-modal-title"
        aria-describedby="spring-modal-description"
        className={classes.modal}
        open={open}
        onClose={handleClose}
        closeAfterTransition
        BackdropProps={{
          timeout: 500,
        }}
      >
        <div className={classes.paper}>
          <h1 id="spring-modal-title">Delete</h1>
          <p id="spring-modal-description">
            Do you want to delete ID {deleteID}
            <br />
            <Button color="secondary" onClick={deleteAPN}>
              Yes
            </Button>
            <Button color="primary" onClick={handleClose}>
              No
            </Button>
          </p>
        </div>
      </Modal>
      <Table className={classes.table} aria-label="a spanning dense table" padding="checkbox">
        <TableHead>
          <TableRow>
            <TableCell colSpan={2} align="left">
              <Box className={classes.search}>
                <span>Search</span>
                <TextField
                  style={{ marginLeft: '10px' }}
                  fullWidth
                  variant="standard"
                  onChange={(e) => {
                    handleSearchField(e?.target.value);
                  }}
                />
              </Box>
            </TableCell>
            <TableCell colSpan={12} align="right">
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'end',
                  padding: '5px',
                }}
              >
                <Pagination
                  color="primary"
                  count={Math.ceil(get_total_area_count / limit)}
                  variant="outlined"
                  shape="rounded"
                  page={get_page_no}
                  onChange={(e, page) => {
                    set_page_no(page);
                  }}
                />
                <Box sx={{ px: 2 }}>
                  <label htmlFor="limit">Set limit:</label>
                  <select
                    onChange={(e: any) => {
                      setLimit(e.target.value);
                      localStorage.setItem('areaLimit', JSON.stringify(e.target.value));
                    }}
                    style={{ cursor: 'pointer', padding: '5px' }}
                    defaultValue={limit}
                  >
                    <option value={10}>10</option>
                    <option value={50}>50</option>
                    <option value={100}>100</option>
                    <option value={150}>150</option>
                    <option value={250}>250</option>
                    <option value={500}>500</option>
                    <option value={1000}>1000</option>
                  </select>
                </Box>
                <Box>
                  <label htmlFor="sort">Sort by:</label>
                  <select
                    value={sortBy}
                    onChange={(e: any) => {
                      setSortBy(e.target.value);
                      localStorage.setItem('sortArea', JSON.stringify(e.target.value));
                    }}
                    style={{ cursor: 'pointer', padding: '5px' }}
                  >
                    <option value={'id:ASC'}>Old to New</option>
                    <option value={'id:DESC'}>New to Old</option>
                    <option value={'name:ASC'}>A to Z</option>
                    <option value={'updated_at:DESC'}>Last Update</option>
                  </select>
                </Box>
              </div>
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell>ID</TableCell>
            <TableCell align="left">Name</TableCell>
            <TableCell align="center">Edit</TableCell>
            <TableCell align="center">Delete</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows?.map((row: any) => (
            <TableRow key={row.id}>
              <TableCell>{row.id}</TableCell>
              <TableCell align="left">{row.name}</TableCell>
              <TableCell align="center">
                <IconButton
                  color="primary"
                  onClick={() => {
                    history.push(`/dashboard/${apiName}/edit/${row.id}`);
                  }}
                >
                  <EditIcon />
                </IconButton>
              </TableCell>
              <TableCell align="center">
                <IconButton
                  color="secondary"
                  onClick={() => {
                    handleOpen(row.id);
                  }}
                >
                  <DeleteIcon />
                </IconButton>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
